export enum AuthorityBankingEntries {
  FINANCIAL_BANKING_ENTRIES_EDIT = '3.5.4',
  FINANCIAL_BANKING_ENTRIES_REVERSE = '3.5.3',
  FINANCIAL_BANKING_ENTRIES_ADD = '3.5.2',
  FINANCIAL_BANKING_ENTRIES_VIEW = '3.5.1',
  FINANCIAL_BANKING_ENTRIES_BANK = '3.5',
}
